import { onResize, removeResizeEvent } from 'common/js/event-utils';
import { makeAutoObservable } from 'mobx';
import { LoadingStrategyFactory } from '../../formats/display/lib/loading-strategy/loading-strategy-factory';

export type OnCreativeResizeCallback = (params: {
  boundingClientRect: DOMRect;
}) => void;

interface CreativeStoreProps {
  formatContext: { context: AdContext };
  removeListener?: boolean;
  onResizeCallback?: OnCreativeResizeCallback;
}

export class CreativeStore {
  formatContext: { context: AdContext };
  _isVertical: boolean | undefined = undefined;
  _removeListener?: boolean = true;
  resizeCallback: () => void;

  private _creativeSize?: DOMRect | undefined = undefined;
  private readonly onResizeCallback?: OnCreativeResizeCallback;

  constructor({
    formatContext,
    removeListener,
    onResizeCallback
  }: CreativeStoreProps) {
    this.formatContext = formatContext;
    this._removeListener = removeListener;
    this.onResizeCallback = onResizeCallback;

    this.resizeCallback = onResize(this.handleResize.bind(this));
    this.onCreativeResize = this.onCreativeResize.bind(this);

    makeAutoObservable(this);
  }

  get creativeSize(): DOMRect | undefined {
    return this._creativeSize;
  }

  handleResize() {
    this._isVertical = window.innerHeight > window.innerWidth;
    LoadingStrategyFactory.getInstance().onResize(this.formatContext);
    if (this._removeListener) {
      removeResizeEvent(this.resizeCallback);
    }
  }

  onCreativeResize(params: { boundingClientRect: DOMRect }) {
    this._creativeSize = params.boundingClientRect;
    this.onResizeCallback?.(params);
  }

  get isVertical() {
    const isVerticalContext = this.formatContext.context.isVertical;

    if (typeof isVerticalContext !== 'undefined') {
      return isVerticalContext;
    }

    if (typeof this._isVertical !== 'undefined') {
      return this._isVertical;
    }

    return window.innerHeight > window.innerWidth;
  }
}
